import React, { useEffect, useState } from "react";
import BookingDetails from "./BookingDetails";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from '../../redux/store'
import Typography from "@mui/material/Typography";
import { submitCancelRequest } from '../../redux/slices/common'
import { CheckCircleOutline } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
    IconButton,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@mui/material";

const Index = ({
    mainActiveTab,
    subActiveTab,
    setSubActiveTab,
    setCancelStatus,
    cancelStatus,
    handleBookingCancel,
    loading,
    setLoading,
    setSelectedIndex,
    selectedIndex,
    setDataOne,
    dataOne,
    setActiveTab,
    activeTab,
    mainTab,
    setBookingData,
    bookingData,
    setBookingDetails,
    bookingDetails,
    setLoader,
    loader,
    handleOpen,
    setDatas,
    datas,
    setDirectList,
    tabItems,
    queryType,
    setIsBookEnq
}) => {
    const router = useRouter()
    const dispatch = useDispatch()
    const { id, type } = router.query
    const { cancelAccepted } = useSelector(state => state.common)
    const [alertShown, setAlertShown] = React.useState(false);
    const [cancelReason, setCancelReason] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [swap, setSwap] = useState(false);
    const [item, setItem] = useState({});
    const [cancelLoader, setCancelLoader] = useState(false);

    const handleBack = () => {
        setIsBookEnq(false);
        if (type) {
            router.replace("/rsldashboard/bookinglist");
            setTimeout(() => {
                setBookingDetails(false);
                setLoading(true);
                const activeType = Number(sessionStorage.getItem("active-type"));
                setSubActiveTab(Number(sessionStorage.getItem("active-sub-type")));
                setDataOne({
                    ...dataOne,
                    type: activeType ? Number(activeType) : Number(6),
                });
            }, 20)
        } else {
            setBookingDetails(false);
            setLoading(true);
            const activeType = Number(sessionStorage.getItem("active-type"));
            setSubActiveTab(Number(sessionStorage.getItem("active-sub-type")));
            setDataOne({
                ...dataOne,
                type: activeType ? Number(activeType) : Number(6),
            });
        }

        handleClose();
    };

    const validateCancellationReason = (reason) => {
        if (!reason || reason.trim() === "") {
            return "Cancellation reason is required.";
        }
        if (reason.trim().length < 5) {
            return "Please enter at least 5 characters.";
        }
        return null; // No error
    };


    const handleSubmit = () => {

        const validationError = validateCancellationReason(cancelReason);
        if (validationError) {
            setErrorMessage(validationError);
        } else {
            setErrorMessage("");
            const obj = {
                "bookingId": item?._id,
                "type": item?.type,
                "cancelRequestNotes": cancelReason
            }
            setCancelLoader(true);
            dispatch(submitCancelRequest(obj))
        }
    }


    useEffect(() => {
        if (cancelAccepted) {
            setCancelLoader(false);
            if (cancelAccepted?.status === 1) {
                setSwap(true);
                setErrorMessage(cancelAccepted?.message);
            }
            else {
                setErrorMessage(cancelAccepted?.message);
            }

        }
    }, [cancelAccepted])

    const handleCancel = () => {
        setAlertShown(true);
    }

    const handleClose = () => {
        setAlertShown(false);
        setSwap(false);
        setErrorMessage("");
        setCancelReason("");
        setCancelLoader(false);
    };

    return (
        <div className="dashboard">
            <div className="dashboard__main-new">
                <div className="dashboard__content main_booking_list">

                    <div className="d-flex justify-content-start align-items-start mb-20">
                        <Box sx={{ display: "flex", gap: 1, width: "100%", maxWidth: 600 }}>


                            {/* <Button
                                variant="contained"
                                startIcon={<KeyboardBackspaceIcon />}
                                onClick={() => handleBack()}
                                sx={{
                                    minWidth: "120px", // ✅ Ensures consistent width
                                    height: "40px", // ✅ Matches input field height
                                    backgroundColor: "#6dc8bf", // ✅ Custom background color
                                    color: "white",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    "&:hover": { backgroundColor: "#5bb8ae" },
                                }}
                            >
                                Back
                            </Button> */}

                            <Button
                                variant="outlined"
                                startIcon={<KeyboardBackspaceIcon />}
                                onClick={() => handleBack()}
                                sx={{
                                    minWidth: "120px",
                                    height: "40px",
                                    color: "#6dc8bf", // Text color
                                    borderColor: "#6dc8bf", // Border color
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    "&:hover": {
                                        borderColor: "#6dc8bf",
                                        backgroundColor: "#6dc8bf",
                                        color: "#ffffff"
                                    },
                                }}
                            >
                                Back
                            </Button>


                        </Box>
                    </div>

                    <div className="d-flex justify-content-between gap-4" style={{ marginBottom: "8px" }}>
                        <div className="row y-gap-20 justify-between items-end">
                            <div className="col-12">
                                <h1 className="text-20 text-md-30 lh-14 fw-600">Booking Summary</h1>
                                <div className="text-15 text-light-1">
                                    Review the details of your booking, including reservation status, itinerary, and payment information.
                                </div>

                                {/* Email & Clear Button Positioned to the Right */}

                            </div>
                        </div>
                        {
                            item?.isEnableRequestForCancel && [1, 2, 4, 6].includes(item?.type) && [0, 1].includes(item?.bookingStatus) &&
                            <div className="d-flex justify-content-end align-items-start">
                                <Box sx={{ display: "flex", gap: 1, width: "100%", maxWidth: 600 }}>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            color: 'grey.700', // text color
                                            borderColor: 'grey.400', // border color
                                            borderWidth: '1px',
                                            borderRadius: "8px",
                                            textTransform: 'none',
                                            '&:hover': {
                                                borderColor: 'grey.600',
                                                backgroundColor: 'grey.100',
                                            },
                                        }}
                                        onClick={handleCancel}
                                    >
                                        Request for Cancel
                                    </Button>

                                </Box>
                            </div>
                        }

                    </div>

                    <div className="dashboard__content_tablist">
                        <div className="rounded-4">
                            <BookingDetails
                                mainActiveTab={mainActiveTab}
                                subActiveTab={subActiveTab}
                                setSubActiveTab={setSubActiveTab}
                                setCancelStatus={setCancelStatus}
                                cancelStatus={cancelStatus}
                                handleBookingCancel={handleBookingCancel}
                                loading={loading}
                                setLoading={setLoading}
                                setSelectedIndex={setSelectedIndex}
                                selectedIndex={selectedIndex}
                                setDataOne={setDataOne}
                                dataOne={dataOne}
                                setActiveTab={setActiveTab}
                                activeTab={activeTab}
                                mainTab={mainTab}
                                setBookingData={setBookingData}
                                bookingData={bookingData}
                                setBookingDetails={setBookingDetails}
                                bookingDetails={bookingDetails}
                                setLoader={setLoader}
                                loader={loader}
                                handleOpen={handleOpen}
                                setDatas={setDatas}
                                datas={datas}
                                setDirectList={setDirectList}
                                tabItems={tabItems}
                                setItem={setItem}
                                item={item}
                            />
                        </div>
                    </div>

                    {/* Request for cancel */}
                    <Dialog
                        open={alertShown}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                borderRadius: "16px",
                                padding: "20px",
                                maxWidth: "600px",
                                margin: "auto",
                                width: "100%"
                            }
                        }}
                    >
                        {
                            !swap ?
                                <Box display="flex" flexDirection="column" p={2}>
                                    <Typography variant="h6" fontWeight={600} mb={1}>
                                        Cancellation Feedback
                                    </Typography>

                                    <DialogContentText style={{ fontSize: "15px", color: "#555" }}>
                                        <TextField
                                            multiline
                                            minRows={4}
                                            placeholder="Please enter a valid reason for cancellation"
                                            fullWidth
                                            onChange={(e) => {
                                                setCancelReason(e.target.value);
                                                if (e.target.value?.length >= 5) {
                                                    setErrorMessage("");
                                                }
                                            }}
                                            error={Boolean(errorMessage)}
                                            helperText={errorMessage}
                                        />
                                    </DialogContentText>
                                </Box> :


                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    textAlign="center"
                                    p={4}
                                >
                                    <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />

                                    <Typography variant="h6" fontWeight={600} gutterBottom>
                                        Cancellation Request Sent
                                    </Typography>

                                    <Typography variant="body1" color="text.secondary" mb={3}>
                                        Your request to cancel has been submitted successfully. Our team will review it shortly.
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        startIcon={<KeyboardBackspaceIcon />}
                                        onClick={() => handleBack()}
                                        sx={{
                                            // minWidth: '150px',
                                            height: '40px',
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            backgroundColor: '#6dc8bf',
                                            '&:hover': { backgroundColor: '#5bb8ae' }
                                        }}
                                    >
                                        Back
                                    </Button>
                                </Box>

                        }


                        {
                            !swap &&
                            <DialogActions
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 1.5,
                                    px: 3,
                                    pb: 2,
                                    alignItems: "end"
                                }}
                            >

                                {
                                    cancelLoader ? <Button
                                        variant="contained"
                                        sx={{
                                            // minWidth: '150px',
                                            height: '40px',
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            backgroundColor: '#6dc8bf',
                                            '&:hover': { backgroundColor: '#5bb8ae' }
                                        }}
                                    >
                                        <CircularProgress size={20} />
                                    </Button> :
                                        <Button
                                            onClick={handleSubmit}
                                            variant="contained"
                                            sx={{
                                                minWidth: "120px", // ✅ Ensures consistent width
                                                height: "40px", // ✅ Matches input field height
                                                backgroundColor: "#6dc8bf", // ✅ Custom background color
                                                color: "white",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                borderRadius: "8px",
                                                textTransform: "none",
                                                "&:hover": { backgroundColor: "#5bb8ae" },
                                            }}
                                        >
                                            Submit
                                        </Button>}
                                <Button
                                    onClick={handleClose}
                                    variant="outlined"
                                    sx={{
                                        color: 'grey.700', // text color
                                        borderColor: 'grey.400', // border color
                                        borderWidth: '1px',
                                        borderRadius: "8px",
                                        textTransform: 'none',
                                        '&:hover': {
                                            borderColor: 'grey.600',
                                            backgroundColor: 'grey.100',
                                        },
                                    }}
                                >
                                    Close
                                </Button>

                            </DialogActions>
                        }

                    </Dialog>


                    {/* <Footer /> */}
                </div>
                {/* End .dashboard__content */}
            </div>

        </div>
    );
};

export default Index;
